import { Autocomplete, Box, Dialog, DialogContent, DialogTitle, TextField, Typography } from '@mui/material'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'
import CloseDialogButton from '../../Shared/Dialogs/CloseDialogButton'

const ChangeOrganization = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate()

  const {
    currentUser: { currentOrganizationKey, selfOrganizations },
    setCurrentOrganizationKey
  } = useAuth()

  const { openLockedOrganizationDialog } = useGlobalContext()

  const handleChange = (_event, value) => {
    const { key: newOrganization, locked, name } = value
    if (currentOrganizationKey === newOrganization) {
      return
    }
    if (locked) {
      setCurrentOrganizationKey({ organizationKey: newOrganization })
      setIsOpen(false)
      navigate('/management/profile')
      openLockedOrganizationDialog(name)
      return
    }
    setCurrentOrganizationKey({ organizationKey: newOrganization })
    setIsOpen(false)
    navigate(0)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        scroll="body"
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle
          variant="h4"
          display="flex"
          justifyContent="center"
        >
          {t('organizations.changeOrganization')}
        </DialogTitle>

        <CloseDialogButton onClose={handleClose} />

        {selfOrganizations?.length > 0 && (
          <DialogTitle
            display="flex"
            justifyContent="center"
          >
            <Box>
              <Typography
                id="organization-change-dialog-title"
                variant="h6"
                align="center"
              >
                {t('organizations.availableOrganizations', {
                  count: selfOrganizations.length
                })}
              </Typography>
            </Box>
          </DialogTitle>
        )}

        <DialogContent>
          <Autocomplete
            id="change-organization-dialog-select-organization"
            options={selfOrganizations}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, value) => option.key === value.key}
            value={selfOrganizations?.find(
              ({ key }) => key === currentOrganizationKey
            )}
            onChange={handleChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('common.choose')}
                variant="standard"
                helperText={t('organizations.inputOrganization')}
              />
            )}
            disableClearable
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ChangeOrganization
